module.exports = __webpack_public_path__ + "20bfd700b1bff7b1f4c2a94414927598.jpg";